
const user = {
    state: {
        authorization:"",
        userId:'',
        NamePass:true,
        visitorId:"",
        isMobile:false
    },

    mutations: {
        authorization(state,msg){
            state.authorization = msg;
            console.log(state.authorization)
        },
        USERID(state,msg){
            state.userId = msg;
            console.log(state.userId)
        },
        NamePass(state,msg) {
            state.NamePass = msg
            console.log(msg)
            console.log(state.NamePass)
        },
        visitorId(state,msg) {
            state.visitorId = msg
            console.log(state.visitorId)
        },
        isMobile(state,msg) {
            state.isMobile = msg ;
            console.log(state.isMobile,'----- isMobile -----')
        },
    },
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/login.js